import React, { useEffect } from 'react';
import useLayoutContext from '@hooks/useLayoutContext';
import { WifiEnabledInstructions } from '@components';
import { useAppContext } from '@contexts/AppContext';
import useHandleRedirect from '@hooks/useHandleRedirect';

const CaptivePortalInstructions = () => {
  const { user } = useAppContext();
  const { setIsCaptivePortal } = useLayoutContext();
  setIsCaptivePortal(true);
  useHandleRedirect(true);

  return !user.preWiredKey ? null : (
    <div className="flex justify-center">
      <div className="p-4 max-w-2xl">
        <WifiEnabledInstructions preWiredKey={user.preWiredKey} />
      </div>
    </div>
  );
};

export default CaptivePortalInstructions;
